var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.0002L12.8885 16.5002M19.5 12.0002H9H19.5ZM9 12.0002L12.8885 7.50016L9 12.0002Z",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.90131V5.0394C16.5 4.75733 16.4426 4.47833 16.3314 4.22004C16.2203 3.96174 16.0578 3.72977 15.8542 3.53878C15.6507 3.34779 15.4104 3.20194 15.1488 3.11044C14.8871 3.01894 14.6097 2.98379 14.334 3.0072L6.334 3.6863C5.83405 3.72875 5.36801 3.96125 5.0283 4.33767C4.68859 4.71409 4.50002 5.20695 4.5 5.71849V18.2808C4.50002 18.7924 4.68859 19.2852 5.0283 19.6616C5.36801 20.0381 5.83405 20.2705 6.334 20.313L14.334 20.9931C14.6098 21.0165 14.8873 20.9814 15.149 20.8898C15.4107 20.7982 15.651 20.6523 15.8546 20.4612C16.0582 20.2701 16.2206 20.038 16.3317 19.7796C16.4428 19.5212 16.5001 19.2421 16.5 18.9599V17.098",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/TitleIcon.5de8d4e2c86544e2ca05028d76e76a56.svg";
export { ForwardRef as ReactComponent };